// extracted by mini-css-extract-plugin
module.exports = {"recipeContainer":"Recipe_recipeContainer__3TFFy","imgContainer":"Recipe_imgContainer__33c1r"};